<template>
  <div v-if="change" class="flex flex-wrap items-baseline gap-2 text-xs">
    <dt class="w-32 shrink-0 text-neutral-500">{{ label }}</dt>
    <dd class="flex flex-wrap items-baseline gap-2">
      <span class="text-neutral-500 line-through">{{ change.from || emptyText }}</span>
      <font-awesome-icon :icon="['far', 'arrow-right']" class="text-neutral-400" />
      <span class="font-bold text-neutral-800">{{ change.to || emptyText }}</span>
    </dd>
  </div>
</template>

<script setup lang="ts">
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { ValueChange } from '@infuse/iam/role/type';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

defineProps<{
  label: string;
  change?: ValueChange;
}>();

const emptyText = computed(() => t('iam.roles.import.emptyValue'));
</script>
